"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var makeError = require("make-error");
function _toDetails(messageOrDetails) {
    if (typeof messageOrDetails === 'object')
        return messageOrDetails;
    return { message: messageOrDetails };
}
function _expandMessage(messageOrDetails, template) {
    var _a = _toDetails(messageOrDetails), message = _a.message, details = tslib_1.__rest(_a, ["message"]);
    return tslib_1.__assign({}, details, { message: template.replace('{{message}}', message) });
}
/**
 * Base error class for all errors emitted by the cache.
 *
 * Note that we rely on make-error so that we can safely extend the built in
 * Error in a cross-platform manner.
 */
var HermesCacheError = /** @class */ (function (_super) {
    tslib_1.__extends(HermesCacheError, _super);
    function HermesCacheError(messageOrDetails) {
        var _this = this;
        var _a = _toDetails(messageOrDetails), message = _a.message, infoUrl = _a.infoUrl;
        _this = _super.call(this, infoUrl ? "[" + infoUrl + "] " + message : message) || this;
        return _this;
    }
    return HermesCacheError;
}(makeError.BaseError));
exports.HermesCacheError = HermesCacheError;
/**
 * The current runtime environment isn't suited to run Hermes.
 */
var InvalidEnvironmentError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidEnvironmentError, _super);
    function InvalidEnvironmentError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvalidEnvironmentError;
}(HermesCacheError));
exports.InvalidEnvironmentError = InvalidEnvironmentError;
/**
 * An error with a query - generally occurs when parsing an error.
 */
var QueryError = /** @class */ (function (_super) {
    tslib_1.__extends(QueryError, _super);
    function QueryError(messageOrDetails, 
    // The path within the query where the error occurred.
    path) {
        var _this = _super.call(this, _expandMessage(messageOrDetails, "{{message}} at " + prettyPath(path))) || this;
        _this.path = path;
        return _this;
    }
    return QueryError;
}(HermesCacheError));
exports.QueryError = QueryError;
/**
 * An error with a read query - generally occurs when data in cache is partial
 * or missing.
 */
var UnsatisfiedCacheError = /** @class */ (function (_super) {
    tslib_1.__extends(UnsatisfiedCacheError, _super);
    function UnsatisfiedCacheError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnsatisfiedCacheError;
}(HermesCacheError));
exports.UnsatisfiedCacheError = UnsatisfiedCacheError;
/**
 * An error thrown when multiple fields within a query disagree about what they
 * are selecting.
 */
var ConflictingFieldsError = /** @class */ (function (_super) {
    tslib_1.__extends(ConflictingFieldsError, _super);
    function ConflictingFieldsError(messageOrDetails, 
    // The path within the query where the error occurred.
    path, 
    // The fields that are conflicting
    fields) {
        var _this = _super.call(this, _expandMessage(messageOrDetails, "Conflicting field definitions: {{message}}"), path) || this;
        _this.path = path;
        _this.fields = fields;
        return _this;
    }
    return ConflictingFieldsError;
}(QueryError));
exports.ConflictingFieldsError = ConflictingFieldsError;
/**
 * An error occurring during a cache operation, associated with a location in
 * the cache.
 */
var OperationError = /** @class */ (function (_super) {
    tslib_1.__extends(OperationError, _super);
    function OperationError(messageOrDetails, 
    // The path from the payload root to the node containing the error.
    prefixPath, 
    // The node id being processed when the error occurred.
    nodeId, 
    // The path within the node where the error occurred.
    path, 
    // A value associated with the error.
    value) {
        var _this = _super.call(this, _expandMessage(messageOrDetails, "{{message}} at " + prettyPath(tslib_1.__spread(prefixPath, path)) + " (node " + nodeId + ")")) || this;
        _this.prefixPath = prefixPath;
        _this.nodeId = nodeId;
        _this.path = path;
        _this.value = value;
        return _this;
    }
    return OperationError;
}(HermesCacheError));
exports.OperationError = OperationError;
/**
 * An error occurring while processing a payload for a write operation.
 */
var InvalidPayloadError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidPayloadError, _super);
    function InvalidPayloadError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvalidPayloadError;
}(OperationError));
exports.InvalidPayloadError = InvalidPayloadError;
/**
 * An error occurring as the result of a cache bug.
 */
var CacheConsistencyError = /** @class */ (function (_super) {
    tslib_1.__extends(CacheConsistencyError, _super);
    function CacheConsistencyError(messageOrDetails, 
    // The path from the payload root to the node containing the error.
    prefixPath, 
    // The node id being processed when the error occurred.
    nodeId, 
    // The path within the node where the error occurred.
    path, 
    // A value that is the subject of the error
    value) {
        var _this = _super.call(this, _expandMessage(messageOrDetails, "Hermes BUG: {{message}}"), prefixPath, nodeId, path) || this;
        _this.prefixPath = prefixPath;
        _this.nodeId = nodeId;
        _this.path = path;
        _this.value = value;
        return _this;
    }
    return CacheConsistencyError;
}(OperationError));
exports.CacheConsistencyError = CacheConsistencyError;
/**
 * Renders a path as a pretty string.
 */
function prettyPath(path) {
    return path.length ? path.join('.') : '[]';
}
//# sourceMappingURL=data:application/json;base64,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